import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StartComponent } from './pages/start/start.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { HerdComponent } from './pages/herd/herd.component';
import { SharedModule } from './modules/shared/shared.module';
import { UdderComponent } from './pages/udder/udder.component';
import { AllPyramidsComponent } from './pages/all-pyramids/all-pyramids.component';
import { UdderResultComponent } from './pages/udder-result/udder-result.component';

import localeSv from '@angular/common/locales/sv';
import { registerLocaleData } from '@angular/common';
import { ScrollRestorationService } from './scroll-position-restoration.service';

registerLocaleData(localeSv);

@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    NotFoundComponent,
    HerdComponent,
    UdderComponent,
    AllPyramidsComponent,
    UdderResultComponent,
  ],
  imports: [BrowserModule, AppRoutingModule, ReactiveFormsModule, SharedModule],
  providers: [{ provide: LOCALE_ID, useValue: 'sv' }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private scrollRestorationService: ScrollRestorationService) {
    /** Init scroll position service */
  }
}
